<template>
  <ExecutionPeriodRadioField :choices="choices" v-on="$listeners" />
</template>

<script>
import ExecutionPeriodRadioField from 'chimera/all/components/form/fields/executionPeriod/ExecutionPeriodRadioField'
import { Selectable } from 'chimera/all/components/models/Selectable'

export default {
  name: 'ExecutionPeriodRadioFormPart',

  components: {
    ExecutionPeriodRadioField,
  },

  /**
   * @returns {object}
   */
  data() {
    return {
      choices: [
        new Selectable(
          this.$i18n.t('field.execution-period.options.within-1-month'),
          this.$i18n.t('field.execution-period.options.within-1-month'),
          this.$i18n.t('field.execution-period.options.within-1-month'),
        ),
        new Selectable(
          this.$i18n.t('field.execution-period.options.1-to-3-months'),
          this.$i18n.t('field.execution-period.options.1-to-3-months'),
          this.$i18n.t('field.execution-period.options.1-to-3-months'),
        ),
        new Selectable(
          this.$i18n.t('field.execution-period.options.3-to-6-months'),
          this.$i18n.t('field.execution-period.options.3-to-6-months'),
          this.$i18n.t('field.execution-period.options.3-to-6-months'),
        ),
        new Selectable(
          this.$i18n.t('field.execution-period.options.more-than-6-months'),
          this.$i18n.t('field.execution-period.options.more-than-6-months'),
          this.$i18n.t('field.execution-period.options.more-than-6-months'),
        ),
        new Selectable(
          this.$i18n.t('field.execution-period.options.in-consultation'),
          this.$i18n.t('field.execution-period.options.in-consultation'),
          this.$i18n.t('field.execution-period.options.in-consultation'),
        ),
      ],
    }
  },
}
</script>
